module.exports = __webpack_public_path__ + "img/loginBc.06b22068.png";